import { FormTreeStoreInstance } from "./types";
import { defaultFormStore } from "./store";
import { createContext, useContext, FC } from "react";

const ZTreeStoreContext = createContext(defaultFormStore)

export const useZTreeStoreContext = () => useContext(ZTreeStoreContext);

export const ZTreeStoreProvider : FC<{ value: FormTreeStoreInstance }> = ({ children, value }) => {
  return (
    <ZTreeStoreContext.Provider value={value}>
      {children}
    </ZTreeStoreContext.Provider>
  )
}
